import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { urlServiceHospitalResources } from '../../constants/hospital-resource.constants';
import { urlServicesPatientAdmin } from '../../constants/patients-admin.constants';
import { RestService } from '../communication-rest/communication-rest.service';
import { ResponseDto } from '../../models/generic/response.dto';
import { TriageGralDto } from '../../models/patient/triage/traige-gral.dto';
import { TriageDto, TriageFullDto } from '../../models/patient/triage/traige.dto';

@Injectable({
  providedIn: 'root'
})
export class TriageService {
  private selectedIndexSubject: BehaviorSubject<number> = new BehaviorSubject<number>(-1);

  urls = urlServicesPatientAdmin.triage;
  urlsCat = urlServiceHospitalResources.catalogManagement;

  constructor(protected restService: RestService) { 
    //console.log("TriageService inicializado");
  }

  // Método para establecer el índice seleccionado
  setSelectedIndex(index: number): void {
    this.selectedIndexSubject.next(index);
  }

  // Método para obtener el índice seleccionado como un observable
  getSelectedIndex(): Observable<number> {
    // Imprime el estado actual del BehaviorSubject en la consola
    //console.log("Índice seleccionado(Mensaje desde el Traige):", this.selectedIndexSubject);
    // Devuelve el BehaviorSubject como un Observable
    return this.selectedIndexSubject.asObservable();
  }

  getHistory(branchId : number, patientId : number, triageType : string){
    return this.restService.get<ResponseDto>(this.urls.history.replace('{branchId}', branchId.toString()).replace('{patientId}', patientId.toString()).replace('{triageType}', triageType))
        .pipe(
            map(res => {
                return this.restService.getResultResponse(res, '', true);
            })
        );
  }

  getTriageById(branchId : number, triageId : number): Observable<ResponseDto>{
    return this.restService.get<ResponseDto>(this.urls.id.replace('{branchId}', branchId.toString()).replace('{triageId}', triageId.toString()))
        .pipe(
            map(res => {
                return this.restService.getResultResponse(res, '', true);
            })
        );
  }

  save(obj: TriageDto){
    return this.restService.post<ResponseDto>(this.urls.save, obj )
        .pipe(
            map(res => {
                return this.restService.getResultResponse(res, '', true);
            })
        );
  }

  sign(triageId : number, doctorId : number){
    return this.restService.put<ResponseDto>(this.urls.sign.replace('{triageId}', triageId.toString()).replace('{doctorId}', doctorId.toString()), null)
        .pipe(
            map(res => {
                return this.restService.getResultResponse(res, '', true);
            })
        );
}  


}
